<template>
    <div>
        <section class="tab-panel--savings">
            <h2> {{ contentHeaderText }} </h2>
            <div class="calc-wrap">
                <div class="filter-sec">
                    <div class="form-filter">
                        <number-input
                            v-model="InitialDeposit"
                            :label="labelInitialDeposit"
                            precision="2"
                            inputmode="decimal"
                        />
                        <number-input
                            v-model="YearsToSave"
                            :label="labelYearsToSave"
                            :show-symbol="false"
                            maxValue="100"
                            inputmode="decimal"
                        />
                        <number-input
                            v-model="AdditionalContribution"
                            :label="labelAdditionalContribution"
                            precision="2"
                            inputmode="decimal"
                        />
                        <on-off-toggle
                            ref="toggle"
                            monthlyId="monthlySaving"
                            yearlyId="yearlySaving"
                            @updateStatus="updateContributionStatus"
                        />
                        <number-input
                            v-model="AnnualInterestRate"
                            :label="labelAnnualInterestRate"
                            :tooltip-link="AnnualInterestRateTooltip"
                            symbol="%"
                            symbol-aligned="left"
                            maxValue="100"
                            precision="2"
                            inputmode="decimal"
                        />
                        <drop-down
                            v-model="CompoundInterval"
                            :label="labelCompoundInterval"
                            :options="CompoundIntervalList"
                            :tooltip-link="CompoundIntervalTooltip"
                        />
                        <div class="form-group">
                            <button class="btn btn-blue btn-full visible-mob" @click="calculate">{{ submitButtonText }}</button>
                            <a href="javascript:void(0)" class="reset-calc hidden-mob" @click="resetFilter()"><span class="lt-icons lt4-Refresh"></span> Reset Calculator</a>
                        </div>
                    </div>
                </div>
                <div class="graph-sec">
                    <div class="graph-header">
                        <div class="graph-header--content">
                            <h4>{{ rightSectionHeaderText }} {{ parseInt(YearsToSave, 10) }} {{ parseInt(YearsToSave, 10) > 1 ? 'years': 'year' }} will be:</h4>
                            <label>{{ formatFigure(EstimatedTotal) }}</label>
                        </div>
                    </div>
                    <div class="graph-type">
                        <div v-if="isPiChartVisible == true" class="circle--graph" :class="{'active': circleGraph}">
                            <label class="graph-title hidden-mob">
                                {{ rightSectionGraphTitle }} {{ new Date().getFullYear() + parseInt(YearsToSave, 10) }}
                            </label>
                            <label class="graph-title visible-mob">
                                {{ rightSectionGraphTitleOnMobile }} {{ new Date().getFullYear() + parseInt(YearsToSave, 10) }}
                            </label>
                            <div class="circle--legend">
                                <label><span class="green-bg"></span>{{ graphContributionOption1 }}</label>
                                <label><span class="blue-bg"></span>{{ graphContributionOption2 }}</label>
                                <label><span class="deep-verde-bg"></span>{{ graphContributionOption3 }}</label>
                            </div>
                            <div class="circle--wrap">
                                <vue-chart
                                    type="pie"
                                    :data="pieChartData"
                                    :options="pieChartOptions"
                                    :width="220"
                                    :height="220"
                                />
                            </div>
                        </div>
                        <div v-if="isBarChartVisible == true" class="bar--graph" :class="{'active': barGraph}">
                            <label class="graph-title hidden-mob"> {{ rightSectionBarChartTitle }} </label>
                            <label class="graph-title visible-mob"> {{ rightSectionBarChartTitleOnMobile }} </label>
                            <div class="bar--wrap">
                                <vue-chart
                                    type="bar"
                                    :data="barChartData"
                                    :options="barChartOptions"
                                    :width="barChartWidth"
                                    :height="barChartHeight"
                                />
                            </div>
                        </div>
                    </div>
                    <ul class="graph-selection visible-mob">
                        <li :class="{'active': circleGraph}" @click="circleGraph=true, barGraph=false"></li>
                        <li :class="{'active': barGraph}" @click="circleGraph=false, barGraph=true"></li>
                    </ul>
                </div>
                <Table
                    v-if="isAmortizationTableVisible == true && AmortizationsByYear && AmortizationsByYear.length > 0"
                    ref="table1"
                    :amortizationsByYear="AmortizationsByYear"
                />
            </div>
        </section>
    </div>
</template>
<script>

    import InvestmentMixin from '../mixin/investment-mixin';

    export default {
        props: {
            labelInitialDeposit: {
                default: '',
            },
            initialDeposit: {
                default: 0,
            },
            labelYearsToSave: {
                default: '',
            },
            yearsToSave: {
                default: '',
            },
            annualInterestRate: {
                default: 0,
            },
            annualInterestRateTooltip: {
                default: '',
            },
            labelAnnualInterestRate: {
                default: '',
            },
        },
        data() {
            return {
                InitialDeposit: this.initialDeposit,
                YearsToSave: this.yearsToSave,
                RateReturn: this.rateReturn,
                RateReturnTooltip: parseInt(this.hideTooltip, 10) ? '' : this.rateReturnTooltip,
                AnnualInterestRate: this.annualInterestRate,
                AnnualInterestRateTooltip: parseInt(this.hideTooltip, 10) ? '' : this.annualInterestRateTooltip,
            };
        },
        methods: {
            resetFilter() {
                this.InitialDeposit = this.formatNumber(this.initialDeposit, { precision: 2 });
                this.YearsToSave = this.yearsToSave;
                this.AdditionalContribution = this.formatNumber(this.additionalContribution, { precision: 2 });
                this.AnnualInterestRate = this.formatNumber(this.annualInterestRate, { precision: 2 });
                this.CompoundInterval = this.compoundInterval;
                this.RateReturnTooltip = parseInt(this.hideTooltip, 10) ? '' : this.rateReturnTooltip;
                this.$refs.toggle.updateStatus();
            },
            calculate() {
                let firstPart = 1;
                let secondPart = 1;
                const rateOfReturnRatio = this.unformatFigure(this.AnnualInterestRate) / 100 / this.unformatFigure(this.CompoundInterval);
                const noOfPaymentPerYear = this.unformatFigure(this.YearsToSave) * this.unformatFigure(this.PaymentPeriods);
                const rate = (1 + rateOfReturnRatio) ** (this.unformatFigure(this.CompoundInterval) / this.unformatFigure(this.PaymentPeriods)) - 1;
                firstPart = this.unformatFigure(this.InitialDeposit) * (1 + rate) ** noOfPaymentPerYear;
                secondPart = this.unformatFigure(this.AdditionalContribution) * (((1 + rate) ** noOfPaymentPerYear - 1) / rate) * (1 + rate);
                this.EstimatedTotal = firstPart + secondPart;
                this.calculateAmortizatiionTableData();
            },
            calculateAmortizatiionTableData() {
                let totalContribution = 0;
                const barChartYearList = [];
                const startingAmountList = [];
                const totalContributionList = [];
                const totalInterestEarnedList = [];
                const AmortizationsYearData = [];
                let principal;
                let compoundIntervalForYear;
                let total;
                let interest;
                let firstPart = 1;
                let secondPart = 1;
                let contribution = 0;
                let totalInterestEarned = 0;
                const rateOfReturnRatio = this.unformatFigure(this.AnnualInterestRate) / 100 / this.unformatFigure(this.CompoundInterval);
                const rate = (1 + rateOfReturnRatio) ** (this.unformatFigure(this.CompoundInterval) / this.unformatFigure(this.PaymentPeriods)) - 1;
                const yearNumber = parseInt(this.YearsToSave, 10);
                for (let year = 0; year < yearNumber; year++) {
                    if (typeof AmortizationsYearData[year] == 'undefined') {
                        AmortizationsYearData[year] = [];
                    }
                    contribution = 0;
                    principal = 0;
                    compoundIntervalForYear = 0;
                    total = 0;
                    interest = 0;
                    firstPart = 1;
                    secondPart = 1;
                    contribution = this.unformatFigure(this.AdditionalContribution) * this.unformatFigure(this.PaymentPeriods);
                    principal = contribution + (year < 1 ? parseInt(this.unformatFigure(this.InitialDeposit), 10) : AmortizationsYearData[year - 1][0].Principal);
                    compoundIntervalForYear = this.unformatFigure(this.PaymentPeriods) * (year + 1);
                    firstPart = this.unformatFigure(this.InitialDeposit) * (1 + rate) ** compoundIntervalForYear;
                    secondPart = this.unformatFigure(this.AdditionalContribution) * (((1 + rate) ** compoundIntervalForYear - 1) / rate) * (1 + rate);
                    total = firstPart + secondPart;
                    interest = total - principal;
                    totalContribution += contribution;
                    const graphYear = new Date().getFullYear() + year;
                    barChartYearList.push(graphYear);
                    startingAmountList.push(this.unformatFigure(this.InitialDeposit));
                    totalContributionList.push(contribution);
                    totalInterestEarnedList.push(interest);
                    AmortizationsYearData[year].push({
                        Year: graphYear,
                        Contribution: contribution,
                        Principal: principal,
                        Interest: interest,
                        Total: total,
                    });
                }
                this.AmortizationsByYear = null;
                this.AmortizationsByYear = AmortizationsYearData;
                if (AmortizationsYearData && AmortizationsYearData.length > 0) {
                    const lastElement = AmortizationsYearData[AmortizationsYearData.length - 1][0];
                    totalInterestEarned = lastElement.Interest;
                    this.MaxEdgeValue = lastElement.Contribution + lastElement.Interest + parseInt(this.unformatFigure(this.InitialDeposit), 10);
                }
                if (this.$refs && this.$refs.table1) {
                    this.$refs.table1.AmortizationsByYear = null;
                    this.$refs.table1.AmortizationsByYear = this.AmortizationsByYear;
                }
                const dataArray = [totalContribution, this.unformatFigure(this.InitialDeposit), totalInterestEarned];
                this.$set(this.pieChartData, 'datasets', []);
                if (this.pieChartData && this.pieChartData.datasets) {
                    this.pieChartData.datasets.push(
                        {
                            label: '',
                            data: dataArray,
                            backgroundColor: [
                                '#00aeef',
                                '#08c177',
                                '#078181',
                            ],
                            borderWidth: 1,
                        },
                    );
                }
                // Bar Graph Settings.
                this.$set(this.barChartData, 'datasets', []);
                if (this.barChartData && this.barChartData.datasets) {
                    this.barChartData.datasets.push({
                        label: 'Starting Amount',
                        backgroundColor: '#08c177',
                        data: startingAmountList,
                        borderWidth: 1,
                        borderColor: '#fff',
                        hoverBorderColor: '#fff',
                    }, {
                        label: 'Total Contributions',
                        backgroundColor: '#00aeef',
                        data: totalContributionList,
                        borderWidth: 1,
                        borderColor: '#fff',
                        hoverBorderColor: '#fff',
                    }, {
                        label: 'Total Interest Earned',
                        backgroundColor: '#078181',
                        data: totalInterestEarnedList,
                        borderWidth: 1,
                        borderColor: '#fff',
                        hoverBorderColor: '#fff',
                    });
                }
                this.$set(this.barChartData, 'labels', []);
                this.barChartData.labels = barChartYearList;
            },
        },
        computed: {
            getFieldValue() {
                return this.unformatFigure(this.InitialDeposit) + this.unformatFigure(this.YearsToSave) + this.unformatFigure(this.AnnualInterestRate) + this.unformatFigure(this.AdditionalContribution) + this.unformatFigure(this.CompoundInterval);
            },
        },
        watch: {
            InitialDeposit: {
                handler() {
                    this.InitialDeposit = this.unformatFigure(this.InitialDeposit) > 0 ? this.InitialDeposit : 1;
                },
            },
        },
        mixins: [InvestmentMixin],
    };
</script>
<style lang="scss">
@import "../../../assets/styles/v2/variables";
</style>
<style src="../../../assets/styles/v2/common.scss" lang="scss"></style>
<style src="../main.scss" lang="scss"></style>
